import GameCardRtpBadges from './modules/GameCardRtpBadges';
import LiveRtpDetails from './modules/LiveRtpDetails';
import LiveRtpGameList from './modules/LiveRtpGameList';
import LiveRtpSidebarItem from './modules/LiveRtpSidebarItem';

const LiveRtpHome: FC<LiveRtpProps> = (props) => {
  switch (props.module) {
    case 'details':
      return <LiveRtpDetails game={props.game} />;
    case 'badges':
      return <GameCardRtpBadges game={props.game} rtpField={props.rtpField} />;
    case 'game-list':
      return <LiveRtpGameList />;
    case 'sidebar-item':
      return <LiveRtpSidebarItem />;
    default:
      return <div />;
  }
};

export default LiveRtpHome;
